import {Formik, Form, Field} from 'formik'
import {useNavigate} from 'react-router-dom'
import {useListView} from '@/components/table/core/ListViewProvider'
import {handleErrors, FormActions} from '@/components/form'
import {SupplierOperation, OpProduct} from '../../core/_models'
import {duplicateBulkOrder} from '../../core/_requests'

const DuplicateForm = () => {
  const navigate = useNavigate()
  const {itemForUpdate, setItemForUpdate, setAction} = useListView()
  const operation = itemForUpdate as SupplierOperation

  const close = () => {
    setAction(undefined)
    setItemForUpdate(undefined)
  }

  return (
    <Formik
      initialValues={{reference: ''}}
      onSubmit={async (values, {setErrors}) => {
        try {
          const res = await duplicateBulkOrder(operation._id)
          
          if (res !== undefined) {
            navigate(`/p2c/supplier/bulk-order/${res._id}`)
            close()
          }
        } catch (e: any) {
          handleErrors(e, setErrors)
        }
      }}
    >
      {({values}) => (
        <Form id="delete-operation" className='form'>
          <table className="table table-rounded table-striped border gy-4 gs-4">
            <thead>
              <tr className="border-bottom fs-6 fw-bold text-muted">
                <th className="min-w-175px pb-2">Product</th>
                <th className="min-w-80px text-center pb-2">Unit Price</th>
                <th className="min-w-80px text-center pb-2">Discount</th>
                <th className="min-w-100px text-center pb-2">Vat</th>
                <th className="w-125px text-start pb-2">Qty</th>
                <th className="min-w-100px text-end pb-2">Total amount</th>
              </tr>
            </thead>
            <tbody>
              {operation.products?.map((p: OpProduct, index: number) => (
                <tr key={`product-${index}`}>
                  <td className="text-start">{p.name}</td>
                  <td className="text-start">{p.amount.toFixed(4)}</td>
                  <td className="text-center">{p.discount}%</td>
                  <td className="text-center">{p.vat}%</td>
                  <td className="text-start">{p.qty}</td>
                  <td className="text-end">
                    { (p.amount * (100 - p.discount) / 100 * p.qty).toFixed(2) }
                  </td>
                </tr>
              ))}
              <tr>
                <td className="text-start fw-bold" colSpan={4}>{operation.products?.length} products</td>
                <td className="text-start fw-bold">
                  {operation.products?.reduce((acc: number, p: OpProduct) => {
                    return acc + p.qty
                  }, 0)}
                </td>
                <td className="text-end fw-bold">
                  {operation.products?.reduce((acc: number, p: OpProduct) => {
                    return acc + Number((p.amount * (100 - p.discount) / 100 * p.qty).toFixed(2));
                  }, 0)}
                </td>
              </tr>
            </tbody>
          </table>

          <Field
            component={FormActions}
            position='end'
            close={close}
          />
        </Form>
      )}
    </Formik>
  )
}

export default DuplicateForm
